import { ButtonColor, ButtonSize, ButtonVariant } from "enums/Button";
import styled from "styled-components";
import { CustomButton } from "./Button.style";

interface ButtonLinkProps {
  $variant?: ButtonVariant;
  $color?: ButtonColor;
  $size?: ButtonSize;
}

// Navigation that looks like a button: an anchor or a router link (pass
// `as="a"` or `as={RouterLink}`) wearing the kit Button's own styles, so it
// stays in step with Button. A neutral small outline unless told otherwise.
export const ButtonLink = styled(CustomButton).attrs<ButtonLinkProps>(
  (props) => ({
    $variant: props.$variant ?? ButtonVariant.Bordered,
    $color: props.$color ?? ButtonColor.Neutral,
    $size: props.$size ?? ButtonSize.Small,
  }),
)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  white-space: nowrap;
`;
